import { render, staticRenderFns } from "./editLostAndFound.vue?vue&type=template&id=7d2c7816&"
import script from "./editLostAndFound.vue?vue&type=script&lang=js&"
export * from "./editLostAndFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports